<template>
  <div class="" v-if="broker != null">
    <div class="text-base text-center">
      <img src="https://img.icons8.com/plasticine/64/000000/confetti.png" class="inline" /><br/>
      Hooray! You're good to go!
    </div>

    <div class="mt-1 text-sm text-gray-700">
      Congratulations, you have completed your <span class="text-blue-500">Personalization Tutorial</span>.
    
      If you wish to change any of these settings, you can always do that via clicking on
      <span class="text-green-600 font-semibold">My Settings</span>
      and then
      <span class="text-green-600 font-semibold">Site Appearance</span>.
    
      There are still many more features you can explore on {{ getAppName }} via our
      
      <router-link 
        :to="{
          name  : 'broker-onboard-home',
          params: {
            brokerId   : $route.params.brokerId
          }
        }"
        tag="a" 
        class="text-blue-600 hover:underline">Tutorials</router-link> page.
      So make sure you check them out.      
    </div>

    <div class="text-center mt-8">
      <router-link 
        :to="{
          name  : 'broker-onboard-home',
          params: {
            brokerId   : $route.params.brokerId
          }
        }"
        tag="a" 
        class="bg-blue-500 hover:bg-blue-600 text-white text-xs uppercase font-semibold px-8 py-4 rounded">Back to Tutorials</router-link>
    </div>

    <div class="text-center mt-8">
      <router-link 
        :to="{
          name  : 'broker-onboard-personalize-four',
          params: {
            brokerId   : $route.params.brokerId
          }
        }"
        tag="a" 
        class="text-gray-600 flex items-center justify-center">

        <svg width="16" height="16" stroke-width="2" class="inline" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#chevron-left"/>
        </svg>

        <span class="hover:underline">Previous</span>
      </router-link>
    </div>
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import PageHeader     from '@/shared/components/headers/PageHeader'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  import { Sketch }     from 'vue-color'
  
  export default {

    components: {
      PageHeader,
      SubmitButton2,
      'sketch-picker': Sketch,
    },

    data () {
      return {
        loading: false,
        broker : null,
      }
    },

    created() {
      this.getBroker({
        brokerId: this.$route.params.brokerId
      }, (broker) => {
        this.broker = broker
        this.broker.header_text = this.broker.header_text == null ? '0' : this.broker.header_text
      })
    },

    computed : {
      backgroundColor : {
        get() {
          return this.broker.header_background
        },

        set(value) {
          this.broker.header_background = value.hex
        }
      },

      textColor() {
        return this.broker.header_text == 0 ? '#fff' : '#000'
      }
    },

    methods : {
      uploadFile($event, fileType) {
        let file     = $event.target.files[0] || $event.dataTransfer.files[0]
        let formData = new FormData()
        formData.append('file', file)
        formData.append('fileType', fileType)
        formData.append('brokerId', this.broker.id)
        this.showLoader("Uploading...")

        axios.post(process.env.VUE_APP_API_URL + '/api/broker/upload', formData, {
          headers: {
            'Content-Type'  : 'multipart/form-data',
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          this.hideLoader()
          this.getCurrentBroker()
        }).catch(function(err) {
          this.hideLoader()
        });
      },
    },
  }
</script>